import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { VideosService } from '../services/videos/videos.service';
import { VIDEOS_API_URL } from '../tokens';

export function provideVideosApi(baseUrl: string): EnvironmentProviders {
  return makeEnvironmentProviders([
    VideosService,
    { provide: VIDEOS_API_URL, useValue: baseUrl }
  ]);
}
